import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
    name: "edpDataNames",
    pure: true,
    standalone: true,
})
export class EdpDataNamesPipe implements PipeTransform {
    transform(ids: string[], namesMap: Map<string, string> | undefined): string[] {
        return namesMap ? ids.map(id => namesMap.get(id) ?? "") : [];
    }
}
